// Mirror of portal/server/middleware/require-role.js's ROLE_RANK so the
// frontend can decide whether to show role-gated affordances (e.g., the
// Resolve button on CommentsPanel) without round-tripping. The server
// remains the source of truth — the gate enforces, the frontend just hides.

export const ROLE_RANK = {
    Subscriber: 1,
    Author: 2,
    Editor: 3,
    Administrator: 4,
};
